<template>
  <div v-if="!userData.checkSms">
    <p class="step-sub-title">
      회원님의 개인정보보호를 위해<br />
      휴대폰 번호 인증을 실시하고 있습니다.
    </p>
    <v-row class="row-cell">
      <v-col cols="12">
        <v-text-field
          label="본인의 휴대 전화 번호를 입력해주세요"
          ref="refCell"
          solo
          height="52"
          required
          v-model="userData.cell"
          type="number"
          :rules="[cellRules.required, cellRules.counter, cellRules.check]"
          @input="changeCell"
        >
        </v-text-field>
        <p class="input-guide input-bottom ml-4">-없이 숫자만 입력해 주세요</p>
      </v-col>
    </v-row>
    <p class="mt-10">
      입력하신 휴대폰 정보가 정확하지 않을 경우 인증문자가 발송되지 않습니다.<br />
      <br />
      1분 이내에 인증문자가 수신되지 않을 경우 정확한 정보로 이곳을 클릭하여
      재시도 해주시기 바랍니다.
    </p>
    <div class="bottom-btn">
      <v-btn
        color="primary"
        x-large
        depressed
        block
        rounded
        @click="$emit('clickSendCode')"
        >인증번호 받기</v-btn
      >
    </div>
  </div>
</template>
<script>
const rulesService = require("@/utils/rules.js");

export default {
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      cellRules: rulesService.cellRules(),
    };
  },
  mounted() {
    this.userData.cell = "";
    setTimeout(() => {
      this.$refs.refCell.focus();
    }, 300);
  },
  methods: {
    changeCell() {},
  },
};
</script>
<style lang="">
</style>